import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { scroller } from "react-scroll";
import "./AllUniversity.scss";
import { getAllUniversityByCountry } from "../../services/getAllUniversityByCountry";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

const AllUniversity = () => {
  const [activeTab, setActiveTab] = useState("");
  const dekstopRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [rawData, setRawData] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [selectedAlphabet, setSelectedAlphabet] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 10;
  

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAllUniversityByCountry();
        setRawData(response.data);
      } catch (error) {
        console.error("Error fetching university data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
  if (dekstopRef && dekstopRef && dekstopRef.current) {
    dekstopRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
}, [activeTab]);
useEffect(() => {
  if (rawData.length > 0) {
    const countryTabs = rawData
      .map((item) => ({
        id: item.countryName.toLowerCase(),
        label: item.countryName,
        university: item.universitiesData.map((uni) => ({
          name: uni.universityName,
          url: uni.universityUrl,
        })),
      }))
      .sort((a, b) => a.label.localeCompare(b.label));

    setTabs(countryTabs);

    // ✅ Default select Canada
    const canadaTab = countryTabs.find(
      (tab) => tab.label.toLowerCase() === "canada"
    );

    if (canadaTab) {
      setActiveTab(canadaTab.id);
    } else if (countryTabs.length > 0) {
      setActiveTab(countryTabs[0].id);
    }
  }
}, [rawData]);

const handleTabClick = (id) => {
  if (activeTab === id) {
    setActiveTab("");
    return;
  }

  setActiveTab(id);
  setSelectedAlphabet(null);
  setCurrentPage(1);
};


 

  const activeUniversities =
    tabs.find((tab) => tab.id === activeTab)?.university || [];

  const filteredUniversities = activeUniversities.filter((university) => {
    if (!selectedAlphabet) return true;
    return university.name.toUpperCase().startsWith(selectedAlphabet);
  });

  const totalPages = Math.ceil(filteredUniversities.length / ITEMS_PER_PAGE);

  const paginatedUniversities = filteredUniversities.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE,
  );

  const handlePaginationClick = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const mobileUniversities = filteredUniversities.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE,
  );

  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
      return pages;
    }

    pages.push(1);

    if (currentPage > 3) {
      pages.push("...");
    }

    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (currentPage < totalPages - 2) {
      pages.push("...");
    }

    pages.push(totalPages);

    return pages;
  };

  return (
    <div className="container mt-5">
      {rawData.length > 0 && (
        <>
         
          <div className="subject-tabs-div mb-5">
            <div className="row">
              <div className="col-lg-4 col-md-4">
                <ul className="ft-link nav-tabs">
                  {tabs.map((tab) => (
                    <li key={tab.id} className={`nav-items`}>
                      <div
                        className={`tab-header d-flex justify-content-between align-items-center ${
                          activeTab === tab.id ? "tab-active" : ""
                        }`}
                        onClick={() => handleTabClick(tab.id)}
                      >
                        <span>{tab.label}</span>
                        <i
                          className={`feather fs-6 visibility-hover ${
                            isMobile && activeTab === tab.id
                              ? "fa-solid fa-chevron-down"
                              : "fa-solid fa-chevron-right"
                          }`}
                        />
                      </div>

                      {isMobile && activeTab === tab.id && (
                        <div id="mobile-universities" className="mt-3" style={{background:"#fff"}} >
                          {mobileUniversities.map((u, i) => (
                            <div key={i}>
                              <Link to={`/university/${u.url}`}>{u.name}</Link>
                              <hr />
                            </div>
                          ))}

                          {totalPages > 1 && (
                            <div className="mobile-pagination">
                              <Pagination>
                                <PaginationItem disabled={currentPage === 1}>
                                  <PaginationLink
                                    previous
                                    onClick={() =>
                                      handlePaginationClick(currentPage - 1)
                                    }
                                  />
                                </PaginationItem>

                                {getPageNumbers().map((p, i) =>
                                  p === "..." ? (
                                    <PaginationItem key={i} disabled>
                                      <PaginationLink>…</PaginationLink>
                                    </PaginationItem>
                                  ) : (
                                    <PaginationItem
                                      key={i}
                                      active={p === currentPage}
                                    >
                                      <PaginationLink
                                        onClick={() => handlePaginationClick(p)}
                                      >
                                        {p}
                                      </PaginationLink>
                                    </PaginationItem>
                                  ),
                                )}

                                <PaginationItem
                                  disabled={currentPage === totalPages}
                                >
                                  <PaginationLink
                                    next
                                    onClick={() =>
                                      handlePaginationClick(currentPage + 1)
                                    }
                                  />
                                </PaginationItem>
                              </Pagination>
                            </div>
                          )}
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              </div>

              {!isMobile && (
                <div className="col-lg-8 col-md-8"  ref={dekstopRef}>
                  <div className="row all-alphabet">
                    <h2 className="mb-4">
                      {tabs.find((tab) => tab.id === activeTab)?.label}
                    </h2>

                    {paginatedUniversities.length > 0 ? (
                      paginatedUniversities.map((university, index) => (
                        <div
                          key={index}
                          className="col-lg-6 col-md-12 col-12 uni-name-container"
                        >
                          <Link
                            to={`/university/${university.url}`}
                            className="university-name text-decoration-none"
                          >
                            {university.name}
                          </Link>
                          <hr className="my-4" />
                        </div>
                      ))
                    ) : (
                      <p className="fs-3">No universities found.</p>
                    )}
                  </div>

                  {totalPages > 1 && (
                    <div className="float-end">
                      <Pagination className="mt-4">
                        <PaginationItem disabled={currentPage === 1}>
                          <PaginationLink
                            previous
                            onClick={() =>
                              handlePaginationClick(currentPage - 1)
                            }
                          />
                        </PaginationItem>

                        {getPageNumbers().map((page, index) =>
                          page === "..." ? (
                            <PaginationItem key={index} disabled>
                              <PaginationLink>...</PaginationLink>
                            </PaginationItem>
                          ) : (
                            <PaginationItem
                              key={index}
                              active={currentPage === page}
                            >
                              <PaginationLink
                                onClick={() => handlePaginationClick(page)}
                              >
                                {page}
                              </PaginationLink>
                            </PaginationItem>
                          ),
                        )}

                        <PaginationItem disabled={currentPage === totalPages}>
                          <PaginationLink
                            next
                            onClick={() =>
                              handlePaginationClick(currentPage + 1)
                            }
                          />
                        </PaginationItem>
                      </Pagination>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AllUniversity;
